import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const LoadingWrapper = ({ isLoading, skeletonLines, children }) => {
    if (isLoading) {
        return (
            <Skeleton
                className="min-w-24"
                baseColor="#ECF2F7"
                highlightColor="#009DD6"
                count={skeletonLines || 1}
            />
        );
    }

    return <>{children}</>;
};
export default LoadingWrapper;
